export default function Fallback() {
  return <img className="app-loading" alt="Please wait..." src="/logo_rect_full_black.svg" />;
}
